import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { EyeIcon } from '../../../../../../utils/SVGIcon';
import { GetDate } from '../../../../../../utils/Show';
import { mkRelativeUrl } from '../../../../../../utils/URL';
import cn from '../../../../../../utils/cn';

function CustomerSubscriptionTr({ item }) {
    const navigate = useNavigate();
    return (
        <tr
            className={cn(
                `group border-b border-primary-100 hover:bg-secondary-50 h-12.5 [&>*:first-of-type]:!pl-5 [&>*:last-of-type]:!pr-5 [&>*:last-of-type]:text-right`,
                {
                    'placeholder-mode': item?.demo
                }
            )}
        >
            <td>
                <span>{item?.id}</span>
            </td>
            <td className="group-hover:font-medium group-hover:text-secondary hover:underline cursor-pointer">
                <Link
                    to={mkRelativeUrl(
                        `/agency/${item?.customerInfo?.agencyId}/customers/${item?.customerInfo?.id}/info`
                    )}
                    className="flex flex-col gap-1"
                >
                    <span>{item?.customerInfo?.organization}</span>
                    <span className="text-xs text-primary-500 truncate max-w-[200px]">
                        {item?.customerInfo?.primaryEmail}
                    </span>
                </Link>
            </td>
            <td className="group-hover:font-medium group-hover:text-secondary hover:underline cursor-pointer">
                <Link to={mkRelativeUrl(`/subscriptions/manage/${item?.id}/info`)}>
                    <span>{item?.subscriptionName}</span>
                </Link>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeSubscriptionStart || 0) || 'No Start Date'}</span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeSubscriptionEnd || 0) || 'No End Date'}</span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeFirstInstallation || 0) || 'No Installed'}</span>
            </td>
            <td className="text-center hidden xl:table-cell">
                <span>{GetDate(item?.timeClientUpdate || 0) || 'No Update Date'}</span>
            </td>
            <td className="text-center hidden xl:table-cell">
                <span>{GetDate(item?.timeClientUpdate) || 'No Update'}</span>
            </td>
            <td className="text-center">
                <span>{item?.installedVersion || 'v0.0'}</span>
            </td>
            <td className="text-center capitalize">
                <span className={item?.status === 'active' ? 'text-success' : 'text-warning'}>
                    {item?.status}
                </span>
            </td>

            <td>
                <span>
                    <button
                        type="button"
                        onClick={() =>
                            navigate(mkRelativeUrl(`/subscriptions/manage/${item?.id}/info`))
                        }
                        data-tooltip-id="myToolTip"
                        data-tooltip-content="View Subscription"
                        className="size-[31px] p-[5px] rounded-[7px] text-secondary-700 hover:text-secondary"
                    >
                        <EyeIcon />
                    </button>
                </span>
            </td>
        </tr>
    );
}

function CustomersSubscriptionTableHeader() {
    return (
        <thead>
            <tr>
                <th scope="col">
                    <span>ID</span>
                </th>
                <th scope="col" className="!text-left w-42">
                    <span>Customer Info</span>
                </th>
                <th scope="col">
                    <span>Application Name</span>
                </th>
                <th scope="col" className="w-30 text-center" title="Subscription Start">
                    <span data-tooltip-id="tblTooltip" data-tooltip-content="Subscription Start">
                        Sub. Start
                    </span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span data-tooltip-id="tblTooltip" data-tooltip-content="Subscription End">
                        Sub. End
                    </span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span data-tooltip-id="tblTooltip" data-tooltip-content="Installed Date">
                        Inst. Date
                    </span>
                </th>
                <th scope="col" className="w-30 text-center hidden xl:table-cell">
                    <span>Update Date</span>
                </th>
                <th scope="col" className="w-30 text-center hidden xl:table-cell">
                    <span>Last Update</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Install Version</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Status</span>
                </th>
                <th scope="col">#</th>
            </tr>
        </thead>
    );
}

function TableWeb({ data }) {
    return (
        <div className="agency_info_subscription_table pb-52 overflow-x-auto">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <CustomersSubscriptionTableHeader />
                <tbody>
                    {data && data?.applications?.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={10} className="!text-left">
                                No Subscription Found!
                            </td>
                        </tr>
                    ) : (
                        data?.applications?.map((item) => (
                            <CustomerSubscriptionTr key={item.id} item={item} />
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default TableWeb;
